import { ReactElement, useContext } from 'react'
import { SchedulingWizardContext } from './SchedulingWizard'
import { PATIENT_STATUS_TYPES } from 'lib/scheduling'

export function PatientStatus(): ReactElement {
  const { back, patientType, setPatientType } = useContext(SchedulingWizardContext)
  return (
    <div className={`flex flex-col gap-y-2 ${back ? `animate-fade-right animate-duration-[400ms]` : ``}`}>
      <span className="text-sm font-medium leading-tight text-neutral-700">What type of patient are you?</span>
      <div className="flex grow flex-col gap-y-1.5 overflow-y-auto">
        {PATIENT_STATUS_TYPES.map((type) => (
          <button
            key={type}
            className={`rounded-lg px-4 py-2 text-left text-neutral-900 shadow-elevation-1 ${
              patientType === type ? `border-2 border-[#0067FD]` : `border`
            } hover:bg-gray-100`}
            style={{
              backgroundColor: patientType === type ? `rgba(0, 134, 255, 0.08)` : `#FFFFFF`,
            }}
            onClick={() => setPatientType(type)}
          >
            <span className="text-sm font-medium leading-[17.5px]">{type}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
